import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLayout from '../components/Admin/AdminLayout';
import AdminDashboard from '../components/Admin/AdminDashboard';
import WithdrawalsManagement from '../components/Admin/WithdrawalsManagement';

function AdminRoutes({ session }) {
  return (
    <AdminLayout session={session}>
      <Routes>
        {/* Default route */}
        <Route path="/" element={<AdminDashboard session={session} />} />
        
        {/* Withdrawals Management */}
        <Route path="/withdrawals" element={<WithdrawalsManagement />} />
        
        {/* Fallback */}
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </AdminLayout>
  );
}

export default AdminRoutes;
